import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from } from 'rxjs';
import { VerifyPhoneNumberComponent } from '../../components/verify-phone-number/verify-phone-number.component';
import { BaseModalSize } from '@shared/ui/modal';
import { RegisterGuestRequest } from '../../models/request.models';

@Injectable({
  providedIn: 'root',
})
export class PageLayoutModalService {
  constructor(private ngbModal: NgbModal) {}

  openVerifyPhoneNumber(registerRequest: RegisterGuestRequest, phoneNumber: string, userUid: string): Observable<boolean> {
    const modal = this.ngbModal.open(VerifyPhoneNumberComponent, { size: BaseModalSize.Large });
    modal.componentInstance.request = registerRequest;
    modal.componentInstance.phoneNumber = phoneNumber;
    modal.componentInstance.userUid = userUid;

    return from(
      modal.result.then(
        () => true,
        () => false
      )
    );
  }
}
